import { render } from "./Create.vue?vue&type=template&id=0045859a&scoped=true&ts=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=0045859a&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0045859a"]])

export default __exports__